import { ServiceFlatNode } from '.';
import { PrtgConstants, ServiceStatus } from '../prtg-constants';

export class ServicesFilter {
    public _statuses: ServiceStatus[];
    get statuses() {
        return this._statuses;
    }
    set statuses(value) {
        this._statuses = value;
        this.flagStatus = this._statuses.reduce((acc: number, cur: number) =>
            acc | cur, 0
        );
    }
    public flagStatus: number;
    public types: string[] = [];

    constructor() {
        this._statuses = [];
        this.flagStatus = PrtgConstants.ServiceDownFlagStatus;
        this.types = [];
    }

    public static mapperFromObject(source: any): ServicesFilter {
        const target = new ServicesFilter();
        Object.assign(target, source);

        return target;
    }

    public applyFilter(flatNodes: ServiceFlatNode[]): ServiceFlatNode[] {
        return flatNodes.filter((flatNode: ServiceFlatNode) =>
            // tslint:disable-next-line: no-bitwise
            !this.flagStatus || (this.flagStatus & flatNode.flagStatus) !== 0
            &&
            (this.types.length === 0 || (this.types.includes(flatNode.typeService)))
        );
    }
}
